/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddBinaryReferenceRequestDto } from '../../models/add-binary-reference-request-dto';
import { BinaryUploadInfoDto } from '../../models/binary-upload-info-dto';

export interface AddBinaryReference$Params {
  sha1: string;
  'X-API-Version'?: string;
      body: AddBinaryReferenceRequestDto
}

export function addBinaryReference(http: HttpClient, rootUrl: string, params: AddBinaryReference$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryUploadInfoDto>> {
  const rb = new RequestBuilder(rootUrl, addBinaryReference.PATH, 'post');
  if (params) {
    rb.path('sha1', params.sha1, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryUploadInfoDto>;
    })
  );
}

addBinaryReference.PATH = '/api/binaries/sha1/{sha1}/refs';
